import { Typography } from '@mui/material';
import React from 'react';

type Props = {
  children?: React.ReactNode;
};

const PageTitle = ({ children }: Props): JSX.Element => {
  return (
    <Typography variant="h4" mb={3}>
      {children}
    </Typography>
  );
};

export default PageTitle;
